import { FlyoutLink } from "@app/shared/Flyouts";
import { FC, RefObject } from "react";
import { ZipJobsFlyout } from "./ZipJobsFlyout";

interface ZipJobsPanelContentLinkProps {
    inline?: boolean;
    projectId: number;
    projectName: string;
    triggerElementOverride?: RefObject<HTMLButtonElement>;
}

export const ZipJobsPanelContentLink: FC<ZipJobsPanelContentLinkProps> = (props: ZipJobsPanelContentLinkProps) => {
    return (
        <FlyoutLink
            classNames={`${props.inline ? "d-inline-block" : "col-12"} action-menu-item side-panel-link font-weight-normal`}
            content={{
                body: (
                    <ZipJobsFlyout projectId={props.projectId} />
                ),
                title: `Jobs - ${props.projectName}`,
            }}
            size="60"
            testId="jobs-panel-content-link__flyout"
            triggerElementOverride={props.triggerElementOverride}
        >
            <i className="fa fa-binoculars pr-1" /> Jobs
        </FlyoutLink>
    );
}

